var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinsHandDuotone = function SvgCoinsHandDuotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.059 16.704a7 7 0 1 1 1.882-9.407M12 40.173h5.22c.681 0 1.358.081 2.018.243l5.516 1.34a8.55 8.55 0 0 0 3.653.086l6.099-1.187a8.4 8.4 0 0 0 4.255-2.215l4.315-4.198a3.006 3.006 0 0 0 0-4.337 3.22 3.22 0 0 0-4.122-.285l-5.029 3.669c-.72.526-1.596.81-2.498.81h-4.856 3.091c1.742 0 3.154-1.373 3.154-3.068v-.614c0-1.407-.985-2.634-2.388-2.974l-4.77-1.16A10 10 0 0 0 23.285 26c-1.93 0-5.422 1.598-5.422 1.598L12 30.05M40 13a7 7 0 1 1-14 0 7 7 0 0 1 14 0M4 29.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 44 6.08 44 7.2 44h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C12 42.48 12 41.92 12 40.8V29.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C10.48 26 9.92 26 8.8 26H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 27.52 4 28.08 4 29.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.059 16.704a7 7 0 1 1 1.882-9.407"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
  })));
};
export default SvgCoinsHandDuotone;